import { LoaderFunction } from "react-router-dom";
import { employeeApi } from "src/api/services/employeeApi";
import { store } from "src/api/store";

export const employeeLoader: LoaderFunction = ({ params }) => {
  if (params.employeeId != null) {
    return store
      .dispatch(employeeApi.endpoints.getEmployee.initiate(params.employeeId))
      .unwrap();
  }
};
